import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import OutsideClick from '../../../functions/OutsideClick';
import { FONT_SIZES, clampFontSize } from '../../../functions/richText';
import { usePopoverPlacement } from '../../../functions/popover';

import './styles.scss';

const LIST_HEIGHT = 260;

const AUTO = 'Авто';

// A size box as in Word: pick a size from the list, or type one and press Enter. value and onChange are in px.
// With onAuto the list starts with «Авто», for a size that follows the calendar's cell; value is then 'auto'.
function FontSizeSelect({ value, onChange, onAuto }) {
    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [text, setText] = useState('');
    const { above } = usePopoverPlacement(ref, isOpen, 0, LIST_HEIGHT);

    const shown = value === 'auto' ? AUTO : (value ? String(value) : '');

    useEffect(() => {
        setText(shown);
    }, [shown]);

    OutsideClick(ref, () => setIsOpen(false));

    const apply = (size) => {
        setIsOpen(false);
        if (!Number.isFinite(size) || size <= 0) {
            setText(shown);
            return;
        }
        onChange(clampFontSize(size));
    };

    const applyTyped = () => {
        if (onAuto && /^(авто|auto)$/i.test(text.trim())) {
            setIsOpen(false);
            onAuto();
        } else {
            apply(parseFloat(text.replace(',', '.')));
        }
    };

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            applyTyped();
        } else if (e.key === 'Escape') {
            e.stopPropagation();
            setText(shown);
            setIsOpen(false);
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            setIsOpen(true);
        }
    };

    return (
        <div className="font-size-select" ref={ref}>
            <input
                className="font-size-input"
                title="Размер шрифта"
                inputMode="decimal"
                value={text}
                onChange={(e) => setText(e.target.value)}
                onFocus={(e) => { e.target.select(); setIsOpen(true); }}
                onBlur={() => setText(shown)}
                onKeyDown={onKeyDown}
            />
            <button
                type="button"
                className="font-size-toggle"
                tabIndex={-1}
                onMouseDown={(e) => { e.preventDefault(); setIsOpen(!isOpen); }}
            />
            {isOpen && (
                <ul className={classNames('font-size-list', { 'font-size-list_above': above })}>
                    {onAuto && (
                        <li
                            className={classNames('font-size-option', { 'font-size-option_selected': value === 'auto' })}
                            title="Размер под ячейку календаря"
                            onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setIsOpen(false); onAuto(); }}
                        >
                            {AUTO}
                        </li>
                    )}
                    {FONT_SIZES.map(size => (
                        <li
                            key={size}
                            className={classNames('font-size-option', { 'font-size-option_selected': size === value })}
                            // Picking closes the list, so the day window mustn't take the press for one outside it.
                            onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); apply(size); }}
                        >
                            {size}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export { FontSizeSelect };
